import { RenderContainer } from "../RenderContainer";
import React, { useEffect, useState } from "react";
import { Renderer, Renderer2, RendererProps } from "../model";
import { ErrorM } from "components/helpers/FormHelpers/ErrorM";
import _, { debounce } from "lodash";
import { useField } from "formik";

const debouncedOnChange = debounce(
  (
    value: string,
    index: number,
    handleOnChange: (value: string, index: number) => void
  ) => {
    if (handleOnChange) {
      handleOnChange(value, index);
    }
  },
  3000 // Wait 3 seconds before updating the value 
);

const CustomCurrency: React.FC<RendererProps> = ({
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
}) => {
  const [inputValue, setInputValue] = useState<number | null | string>(null);
  const [{ value }] = useField(field.name);

  useEffect(() => {
    if (value[index].value && typeof value[index].value === "string") {
      setInputValue(value[index].value);
    } else if (value[index].value && typeof value[index].value === "number") {
      setInputValue(value[index].value);
    }
  }, [value]);

  const debounceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    if (handleOnChange) {
      const newValue = e.target.value;
      setInputValue(newValue);
      debouncedOnChange(newValue, index, handleOnChange);
    }
  };
  return (
    <RenderContainer
      customFieldName={customField.name}
      classWrapper={classWrapper}
      orderNumber={customField.orderNumber}
    >
      <React.Fragment>
        {handleOnChange && (
          <>
            <input
              className={`EditBox${readOnly ? " ViewOnly" : ""} ${
                classWrapper ? classWrapper : ""
              }`}
              value={
                readOnly ? (inputValue ? inputValue : "-") : inputValue ?? ""
              }
              type={readOnly ? "text" : "number"}
              step="any"
              readOnly={readOnly}
              onChange={e => debounceChange(e)}
              onBlur={e => handleOnChange(e.target.value, index)}
            />
            <ErrorM name={customField.name} />
          </>
        )}
      </React.Fragment>
    </RenderContainer>
  );
};

export const customCurrency: Renderer2 = (
  customField,
  index,
  readOnly,
  handleOnChange,
  field,
  isMulti,
  classWrapper,
  booleanField
) => (
  <CustomCurrency
    customField={customField}
    index={index}
    readOnly={readOnly}
    handleOnChange={handleOnChange}
    field={field}
    isMulti={isMulti}
    classWrapper={classWrapper}
    booleanField={booleanField}
  />
);
